/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import {declareEntity} from '../fw/MetaDataHelper.ts';
import {PERM_EDIT_PERMISSIONS, ROLE_OWNER as ROLE_OWNER_, ROLE_ADMIN as ROLE_ADMIN_, ROLE_MANAGER as ROLE_MANAGER_, ROLE_USER as ROLE_USER_} from "../util/Permission";
import { NOTIFY_FREQ } from './UserType';

export const ROLE_OWNER = ROLE_OWNER_;
export const ROLE_ADMIN = ROLE_ADMIN_;
export const ROLE_MANAGER = ROLE_MANAGER_;
export const ROLE_USER = ROLE_USER_;


export const OrganisationRole = {
    [ROLE_USER]: {
        name: "User",
    },
    [ROLE_MANAGER]: {
        name: "Manager",
    },
    [ROLE_ADMIN]: {
        name: "Administrator",
    },
    [ROLE_OWNER]: {
        name: "Owner",
    }
};

export const NOTIFY_FREQ_O2U = {
    'daily': {
        name: 'Daily',
    },
    'weekly': {
        name: 'Weekly',
    },
    '6hours': {
        name: 'Every 6 hours',
    },
    '2hours': {
        name: 'Every 2 hours',
    },
    'hourly': {
        name: 'Hourly',
    },
    'global': {
        name: 'Global settings',
    },
};



export default declareEntity({
    entity: "organisation2user",
    graphQL: "Organisation2User",
    name: "Users in organisation",
    dynamoPrefix: 'org',
    storageType: 'central',
    userEditable: false, // all modyfying operation
    userUpdatable: true, // allow editing
    userDeletable: true, // allow remove
    writePermission: [
        PERM_EDIT_PERMISSIONS,
    ],
    fields: (types) => { return {
        id: {
            name: "User ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        user: {
            name: "User",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        externalId: {
            name: "External ID",
            type: "string",
            defaultValue: "",
            filterable: true,
        },
        organisation: {
            name: "Organisation",
            type: "relation",
            to: () => types['organisations'],
            userEditable: false,
        },
        permissions: {
            name: "Permissions in organisation",
            type: "object",
            defaultValue: [],
            userEditable: false,
            hideInApi: true,
        },
        disabledInPanel: {
            name: "Disabled use in panel",
            type: "boolean",
            defaultValue: false,
            hideInApi: true,
        },
        notifyErrors: {
            name: "Notify Errors",
            type: "boolean",
            defaultValue: false,
        },
        notifyErrorsFreq: {
            name: "Notify Frequency",
            type: "enum",
            defaultValue: "global",
            values: {
                'global': {
                    name: 'Global settings',
                },
                ...NOTIFY_FREQ,
            },
            visibility: (data) => data.notifyErrors,
        },
        notifyLastReportTime: {
            name: "Notify Last report time",
            type: "datetime",
            visibility: (data) => data.notifyErrors,
        },
        role: {
            name: "Role",
            type: "enum",
            defaultValue: ROLE_ADMIN,
            values: OrganisationRole,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
    }; }
});
